import { useState, useEffect } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { FlaskConical, ExternalLink } from "lucide-react";

const btn = "inline-flex items-center gap-1.5 border border-slate-300 px-3 py-2 rounded-sm text-xs font-semibold hover:border-coral disabled:opacity-40";
const Lien = ({ href, children, testid }) => href ? <a href={href} target="_blank" rel="noreferrer" data-testid={testid} className="inline-flex items-center gap-1 text-coral-dark text-xs font-semibold">{children} <ExternalLink className="h-3 w-3" /></a> : null;

export const TestPagePanel = ({ st }) => {
  const [confs, setConfs] = useState([]);
  const [cid, setCid] = useState("");
  const [essai, setEssai] = useState({});
  const [busy, setBusy] = useState(false);
  const testPage = st.pages.find((p) => p.urn === st.config.test_urn);
  useEffect(() => {
    api.get("/admin/conferences", { params: { essai: true } }).then((r) => {
      const ok = r.data.conferences.filter((c) => c.statut_api === "pret");
      setConfs(ok); setCid(ok[0]?.id || "");
    }).catch(() => {});
    api.get("/admin/conferences/page-test/essai").then((r) => setEssai(r.data.essai || {})).catch(() => {});
  }, []);
  const run = async (action, ok) => {
    setBusy(true);
    try { const { data } = await api.post(`/admin/conferences/page-test/essai/${action}`, null, { params: action === "publier" ? { cid } : {} }); setEssai(data.essai); toast.success(ok); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };
  const live = essai.post_urn && !essai.retire_le;
  return (
    <div className="mt-5 border-t border-slate-200 pt-4" data-testid="test-page-panel">
      <p className="text-xs font-semibold uppercase tracking-[0.12em] text-[#B45309] inline-flex items-center gap-1.5 mb-2"><FlaskConical className="h-3.5 w-3.5" /> Essai sur la page de test « {testPage?.nom} »</p>
      <div className="flex flex-wrap gap-2 items-center">
        <select value={cid} onChange={(e) => setCid(e.target.value)} disabled={live} data-testid="test-page-conf-select" className="border border-slate-300 rounded-sm px-2 py-1.5 text-sm bg-white max-w-full">
          {confs.length === 0 && <option value="">Aucune conférence d'essai prête</option>}
          {confs.map((c) => <option key={c.id} value={c.id}>{c.groupe?.nom} · {c.conferencier?.prenom} {c.conferencier?.nom}</option>)}
        </select>
        <button onClick={() => run("publier", "Essai publié sur la page de test")} disabled={busy || live || !cid} data-testid="test-page-publish-btn" className="bg-ink text-white px-3 py-2 rounded-sm text-xs font-semibold disabled:opacity-40">Publier un essai</button>
        <button onClick={() => run("republier", "Essai republié par APOLLO France")} disabled={busy || !live || essai.repost_urn || !st.config.france_urn} data-testid="test-page-reshare-btn" className={btn}>Republier (APOLLO France)</button>
        <button onClick={() => run("retirer-republication", "Republication d'essai supprimée")} disabled={busy || !essai.repost_urn} data-testid="test-page-unshare-btn" className={btn}>Supprimer la republication</button>
        <button onClick={() => window.confirm("Retirer l'essai de LinkedIn ?") && run("retirer", "Essai retiré")} disabled={busy || !live} data-testid="test-page-retract-btn" className={btn}>Retirer l'essai</button>
      </div>
      {essai.post_urn && (
        <p className="text-xs text-slate-500 mt-2 space-x-3" data-testid="test-page-status">
          <span>Post : <code>{essai.post_urn}</code></span><Lien href={!essai.retire_le && essai.post_url} testid="test-page-post-link">Voir le post</Lien>
          {essai.repost_urn && <Lien href={essai.repost_url} testid="test-page-repost-link">Voir la republication</Lien>}
          {essai.retire_le && <span className="font-semibold">Retiré</span>}
        </p>
      )}
    </div>
  );
};

export default TestPagePanel;
